
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/livingstone-stay",
      function () {
        return require("private-next-pages/case-study/livingstone-stay.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/livingstone-stay"])
      });
    }
  